import { gql } from "@apollo/client";

export const GET_ALIMENTACION_PARENTERAL = gql`
    query AlimentacionParenteralRIByDatosGeneralesId (
        $idDatosGenerales: Int!
    ) {
        alimentacionParenteralRIByDatosGeneralesId (
            idDatosGenerales: $idDatosGenerales
        ){
            idAlimentacionParenteralRI
            
            idComboRIValorKarnofsky
            comboRIValorKarnofsky
            calorias
            hidratosCarbono
            proteinas
            lipidos
            proteinasTotales
            lipidosTotales
            caloriasTotales
            formulaSchofieldPed
            laboratorio
            laboratorioAdjunto{
                contentType
                titulo
                archivo
                extension
            }

            idComboRIValorTipoCateter
            comboRIValorTipoCateter
            justificarTipoCateter
            fechaColocacionCateter
            idComboRIValorUbicacionCateter
            comboRIValorUbicacionCateter
            idComboRIValorNroLumenes
            comboRIValorNroLumenes
            insercionCateterNormal
            magistral
            bAPestandar
            idComboRIValorMotivoIndicacionEstandar
            comboRIValorMotivoIndicacionEstandar
            bAPxAdelantado
            idComboRIValorModoInfusion
            comboRIValorModoInfusion
            idComboRIValorSelladoCateter
            comboRIValorSelladoCateter
            volumenMagistral
            diaConexionMagistral
            diaConexionEstandar
            indicacionRI{
                idInsumo
                cantidadDiaria
                idInsumoNavigation{
                    descripcion
                }
            }
        }
    }
`;